import React from 'react';

/**
 * Agency overview page.
 */
export const Dashboard = () => {
  return (
    <div>
      <h2>Agency Dashboard</h2>
    </div>
  );
};
